import { render, staticRenderFns } from "./OfferCallback.vue?vue&type=template&id=8fe24720&scoped=true"
import script from "./OfferCallback.vue?vue&type=script&lang=js"
export * from "./OfferCallback.vue?vue&type=script&lang=js"
import style0 from "./OfferCallback.vue?vue&type=style&index=0&id=8fe24720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe24720",
  null
  
)

export default component.exports